var Backbone, SupportBasePopupViewTemplate, SupportbasePopupView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePopupViewTemplate = require('../../base_popup_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportbasePopupView = (function(superClass) {
  extend(SupportbasePopupView, superClass);

  function SupportbasePopupView() {
    return SupportbasePopupView.__super__.constructor.apply(this, arguments);
  }

  SupportbasePopupView.prototype.initialize = function(options) {
    this.I18nScope = 'modules.support';
    this.template = SupportBasePopupViewTemplate;
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.popup = $("#popup");
    return this.popupView = options.popupView;
  };

  SupportbasePopupView.prototype.renderHeaderAndFooter = function() {
    return toHtml(this.template, {}, this.I18nScope);
  };

  SupportbasePopupView.prototype.render = function() {
    var addEl;
    GIG.Modal.open({
      el: this.popup,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.$el.html(this.renderHeaderAndFooter());
    this.popup.html(this.el);
    this.popupView.render();
    addEl = $(this.el).find('.itemsPopupData');
    addEl.append(this.popupView.el);
    return this.delegateEvents();
  };

  SupportbasePopupView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SupportbasePopupView.prototype.events = {
    'click .close-modal': "closeModal"
  };

  return SupportbasePopupView;

})(Backbone.View);

module.exports = SupportbasePopupView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvYmFzZV9wb3B1cF92aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2Jhc2VfcG9wdXBfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw0REFBQTtFQUFBOzs7QUFBQSw0QkFBQSxHQUErQixPQUFBLENBQVEscUNBQVI7O0FBQy9CLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUVQOzs7Ozs7O2lDQUNKLFVBQUEsR0FBWSxTQUFDLE9BQUQ7SUFDVixJQUFDLENBQUEsU0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtJQUNaLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBVixDQUFnQixDQUFoQixFQUFtQixDQUFDLElBQUQsQ0FBTSxDQUFDLE1BQVAsQ0FBYyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVosQ0FBZCxDQUFuQjtJQUNBLElBQUMsQ0FBQSxLQUFELEdBQVMsQ0FBQSxDQUFFLFFBQUY7V0FDVCxJQUFDLENBQUEsU0FBRCxHQUFhLE9BQU8sQ0FBQztFQUxYOztpQ0FPWixxQkFBQSxHQUF1QixTQUFBO1dBQ3JCLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixFQUFsQixFQUFzQixJQUFDLENBQUEsU0FBdkI7RUFEcUI7O2lDQUd2QixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxHQUFHLENBQUMsS0FBSyxDQUFDLElBQVYsQ0FDRTtNQUFBLEVBQUEsRUFBSSxJQUFDLENBQUEsS0FBTDtNQUNBLGNBQUEsRUFBZ0IsSUFEaEI7TUFFQSxhQUFBLEVBQWUsSUFGZjtLQURGO0lBSUEsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsSUFBQyxDQUFBLHFCQUFELENBQUEsQ0FBVjtJQUNBLElBQUMsQ0FBQSxLQUFLLENBQUMsSUFBUCxDQUFZLElBQUksQ0FBQyxFQUFqQjtJQUNBLElBQUMsQ0FBQSxTQUFTLENBQUMsTUFBWCxDQUFBO0lBQ0EsS0FBQSxHQUFRLENBQUEsQ0FBRSxJQUFDLENBQUEsRUFBSCxDQUFNLENBQUMsSUFBUCxDQUFZLGlCQUFaO0lBQ1IsS0FBSyxDQUFDLE1BQU4sQ0FBYSxJQUFDLENBQUEsU0FBUyxDQUFDLEVBQXhCO1dBQ0EsSUFBQyxDQUFBLGNBQUQsQ0FBQTtFQVZNOztpQ0FZUixVQUFBLEdBQVksU0FBQTtJQUNWLEdBQUcsQ0FBQyxLQUFLLENBQUMsS0FBVixDQUFBO0FBQ0EsV0FBTztFQUZHOztpQ0FJWixNQUFBLEdBQ0U7SUFBQSxvQkFBQSxFQUF1QixZQUF2Qjs7Ozs7R0E1QitCLFFBQVEsQ0FBQzs7QUE4QjVDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
